import { apiGet } from "../../utils"

export function getVReleaseHistoryAPI(data) {
    // const { sort = '' } = data || {}
    return apiGet(`/api/getVReleaseHistory`, data)
}